

/// <reference path="CoreAccounting.ts" />

// Generated class DBCoreDocument_ManagedObject

class DBCoreDocument_ManagedObject extends CoreAccounting
{

    // Property: ocrError
    set ocrError(value:string) {
        this.setValueForKey(value, 'ocrError');
    }
    get ocrError():string {
        return this.valueForKey('ocrError');
    }
    set ocrErrorPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'ocrError');
    }
    get ocrErrorPrimitiveValue():string {
        return this.primitiveValueForKey('ocrError');
    }

    // Property: ocrResponseRaw
    set ocrResponseRaw(value:any) {
        this.setValueForKey(value, 'ocrResponseRaw');
    }
    get ocrResponseRaw():any {
        return this.valueForKey('ocrResponseRaw');
    }
    set ocrResponseRawPrimitiveValue(value:any) {
        this.setPrimitiveValueForKey(value, 'ocrResponseRaw');
    }
    get ocrResponseRawPrimitiveValue():any {
        return this.primitiveValueForKey('ocrResponseRaw');
    }

    // Property: ocrStatus
    set ocrStatus(value:number) {
        this.setValueForKey(value, 'ocrStatus');
    }
    get ocrStatus():number {
        return this.valueForKey('ocrStatus');
    }
    set ocrStatusPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'ocrStatus');
    }
    get ocrStatusPrimitiveValue():number {
        return this.primitiveValueForKey('ocrStatus');
    }

    // Relationship: files
    protected _files:MIOManagedObjectSet = null;
    get files():MIOManagedObjectSet {
        return this.valueForKey('files');
    }
    addFilesObject(value:FileAttachment) {
        this._addObjectForKey(value, 'files');
    }
    removeFilesObject(value:FileAttachment) {
        this._removeObjectForKey(value, 'files');
    }
}
